<app-loader *ngIf="isLoading"></app-loader>
<div class="review-container">
  @if (isLoaded()) {
  <!-- Stepper + page actions -->
  <div class="review-top">
    <div class="upload-card-head">
      <div class="title-row">
        <h2>{{ labels.REVIEW_REFINE.EYEBROW }}</h2>
        <h2 class="screen-title-green">{{ labels.REVIEW_REFINE.REVIEW }}</h2>
      </div>
    </div>
    <div class="custom-stepper">
      <div class="step done">
        <div class="circle"><mat-icon class="initial-center">check</mat-icon></div>
        <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
      </div>
      <div class="line"></div>
      <div class="step done">
        <div class="circle"><mat-icon class="initial-center">check</mat-icon></div>
        <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
      </div>
      <div class="line"></div>
      <div class="step active">
        <div class="circle">
          <div class="initial-center">3</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
      </div>
      <div class="line"></div>
      <div class="step">
        <div class="circle">
          <div class="initial-center">4</div>
        </div>
        <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
      </div>
    </div>
  </div>

  <!-- Report header -->
  <div class="report-head">
    @if (header(); as details) {
    <div class="report-head-row">
      <div class="report-icon-wrap" aria-hidden="true">
        <img src="/assets/icons/report_green.svg" alt="" />
      </div>
      <div class="report-content">
        <h2 class="report-title">{{ header()?.reportName }}</h2>
        <div class="report-meta report-meta-details">
          @if (details.projectId) {
          <span>
            <span class="meta-label">{{ labels.REVIEW_REFINE.PROJECT_ID }}</span>
            {{ details.projectId }}
          </span>
          }
          @if (details.owner.displayName) {
          <span>
            <span class="meta-label">{{ labels.REVIEW_REFINE.OWNER }}</span>
            {{ details.owner.displayName }}
          </span>
          }
          @if (details.dateCreated) {
          <span>
            <span class="meta-label">{{ labels.REVIEW_REFINE.CREATED }}</span>
            {{ details.dateCreated | date: 'dd MMM yyyy' }}
          </span>
          }
        </div>
      </div>
      <div class="head-chips">
        @if (details.statusLabel) {
        <span class="chip chip-status">{{ details.statusLabel }}</span>
        }
        <!-- @if (dataSourceCount() > 0) {
        <span class="chip chip-olive">
          {{ dataSourceCount() }}
          {{
          dataSourceCount() === 1
          ? labels.REVIEW_REFINE.DATA_SOURCE
          : labels.REVIEW_REFINE.DATA_SOURCES
          }}
        </span>
        } -->
        <span class="chip chip-olive">{{ sections().length }} {{ labels.REVIEW_REFINE.SECTIONS }}</span>
        @if (details.clientName) {
        <span class="chip chip-client">{{ details.clientName }}</span>
        }
      </div>
    </div>
    }
  </div>

  <!-- Metric tiles + change-review progress: pinned while the section list scrolls -->
  <div class="review-summary">
    <div class="metrics-row">
      <!-- Each tile filters the section list; clicking the active one clears it. -->
      <button type="button" class="metric-tile tile-pending" [class.is-active]="activeFilter() === 'pending'"
        [attr.aria-pressed]="activeFilter() === 'pending'" [title]="labels.REVIEW_REFINE.FILTER_HINT"
        [disabled]="metrics().pending === 0" (click)="toggleFilter('pending')">
        <span class="metric-value">{{ metrics().pending }}</span>
        <span class="metric-label">{{ labels.REVIEW_REFINE.PENDING }}</span>
      </button>
      <button type="button" class="metric-tile tile-reviewed" [class.is-active]="activeFilter() === 'reviewed'"
        [attr.aria-pressed]="activeFilter() === 'reviewed'" [title]="labels.REVIEW_REFINE.FILTER_HINT"
        [disabled]="metrics().reviewed === 0" (click)="toggleFilter('reviewed')">
        <span class="metric-value">{{ metrics().reviewed }}</span>
        <span class="metric-label">{{ labels.REVIEW_REFINE.REVIEWED }}</span>
      </button>
      <button type="button" class="metric-tile tile-unchanged" [class.is-active]="activeFilter() === 'unchanged'"
        [attr.aria-pressed]="activeFilter() === 'unchanged'" [title]="labels.REVIEW_REFINE.FILTER_HINT"
        [disabled]="metrics().unchanged === 0" (click)="toggleFilter('unchanged')">
        <span class="metric-value">{{ metrics().unchanged }}</span>
        <span class="metric-label">{{ labels.REVIEW_REFINE.UNCHANGED }}</span>
      </button>
      <button type="button" class="metric-tile tile-flags" [class.is-active]="activeFilter() === 'flagged'"
        [attr.aria-pressed]="activeFilter() === 'flagged'" [title]="labels.REVIEW_REFINE.FLAG_REASON"
        [disabled]="metrics().flagged === 0" (click)="toggleFilter('flagged')">
        <span class="metric-value">{{ metrics().flagged }}</span>
        <span class="metric-label">
          <mat-icon class="flag-icon">flag</mat-icon>{{ labels.REVIEW_REFINE.FLAGS }}
        </span>
      </button>

      <div class="progress-card">
        <div class="progress-head">
          <span>{{ labels.REVIEW_REFINE.CHANGE_REVIEW }}</span>
          <span>{{ progress().decided }}/{{ progress().total }}
            {{ labels.REVIEW_REFINE.DECIDED }}</span>
        </div>
        <div class="progress-track" role="progressbar" [attr.aria-valuenow]="acceptedPercent()" aria-valuemin="0"
          aria-valuemax="100">
          <div class="progress-fill" [style.width.%]="acceptedPercent()"></div>
        </div>
        <div class="progress-legend">
          <span class="legend-item legend-accepted">
            {{ labels.REVIEW_REFINE.CONFIRMED }} - {{ progress().accepted }}
          </span>
          <span class="legend-item legend-declined">
            {{ labels.REVIEW_REFINE.DECLINED }} - {{ progress().declined }}
          </span>
          <span class="legend-item legend-pending">
            {{ labels.REVIEW_REFINE.PENDING }} - {{ progress().pending }}
          </span>
        </div>
      </div>
    </div>

    @if (activeFilter()) {
    <p class="filter-bar">
      {{ labels.REVIEW_REFINE.SHOWING }} {{ visibleSections().length }}
      {{ labels.REVIEW_REFINE.OF }} {{ sections().length }}
      {{ labels.REVIEW_REFINE.SECTIONS }}
      <button type="button" class="filter-clear" (click)="clearFilter()">
        <mat-icon class="btn-icon">close</mat-icon>
        {{ labels.REVIEW_REFINE.CLEAR_FILTER }}
      </button>
    </p>
    }

    <p class="ai-note-bar">
      {{ allDecided() ? labels.REVIEW_REFINE.ALL_DECIDED : labels.REVIEW_REFINE.NOTE }}
    </p>
  </div>

  <!-- Contents rail + section list -->
  <div class="review-layout">
    <div class="rail-container">
      <aside class="contents-rail">
        <h3 class="rail-title">{{ labels.REVIEW_REFINE.CONTENTS }}</h3>
        <div class="rail-scroll">
          <ul class="rail-list">
            <ng-container *ngTemplateOutlet="railNodes; context: { $implicit: contents() }"></ng-container>
          </ul>

          <!-- Recursive rail: renders each node and its children to arbitrary depth. -->
          <ng-template #railNodes let-nodes>
            @for (node of nodes; track node.section.id) {
            <li>
              <button type="button" class="rail-item" [class.active]="activeSectionId() === node.section.id"
                (click)="selectSection(node.section.id)">
                <span class="rail-dot" [ngClass]="sectionDotClass(node.section)"></span>
                <span class="rail-text">{{ node.section.sectionTitle }}</span>
                @if (pendingCount(node.section) > 0) {
                <span class="rail-count">{{ pendingCount(node.section) }}</span>
                }
              </button>
              @if (node.children.length) {
              <ul class="rail-children">
                <ng-container *ngTemplateOutlet="railNodes; context: { $implicit: node.children }"></ng-container>
              </ul>
              }
            </li>
            }
          </ng-template>
        </div>
      </aside>
    </div>

    <div class="section-list-container">
      <div class="section-list">
        @for (section of visibleSections(); track section.id) {
        <article class="section-card" [id]="'reviewSection-' + section.id" [class.is-changed]="section.changed"
        [class.is-active]="activeSectionId() === section.id" (click)="activeSectionId.set(section.id)">
        <header class="section-header">
          <span class="section-title">
            {{ section.sectionNumber }} · {{ section.sectionTitle }}
          </span>

          @if (!section.changed) {
          <span class="badge badge-unchanged">{{ labels.REVIEW_REFINE.UNCHANGED }}</span>
          }

          @if (confirmedCount(section) > 0) {
          <span class="badge badge-accepted">
            {{ labels.REVIEW_REFINE.CONFIRMED }} - {{ confirmedCount(section) }}
          </span>
          }

          @if (declinedCount(section) > 0) {
          <span class="badge badge-declined">
            {{ labels.REVIEW_REFINE.DECLINED }} - {{ declinedCount(section) }}
          </span>
          }

          @if (editedCount(section) > 0) {
          <span class="badge badge-edited">{{ labels.REVIEW_REFINE.EDITED }}</span>
          }

          @if (pendingCount(section) > 0) {
          <span class="badge badge-pending">
            {{ labels.REVIEW_REFINE.PENDING }} - {{ pendingCount(section) }}
          </span>
          }

          @if (isReviewRequired(section)) {
          <span class="badge badge-review-required">
            {{ labels.REVIEW_REFINE.REVIEW_REQUIRED }}
          </span>
          }
        </header>

        <!-- Section body: prior report text, changed runs highlighted -->
        <div class="section-body">
          @if (editingSectionId() === section.id) {
          <div class="section-editor">
            <textarea rows="8" class="section-edit-input" [(ngModel)]="sectionDraft"
              [placeholder]="labels.REVIEW_REFINE.SECTION_EDIT_PLACEHOLDER"></textarea>
            <div class="editor-actions">
              <button type="button" class="aecom_btn" (click)="cancelSectionEdit()">
                {{ labels.REVIEW_REFINE.BUTTON.CANCEL }}
              </button>
              <button type="button" class="aecom_btn--solid" (click)="saveSectionEdit(section)">
                {{ labels.REVIEW_REFINE.BUTTON.SAVE }}
              </button>
            </div>
          </div>
          } @else {
          <div class="section-content" [innerHTML]="section.previousContentHtml"></div>
          }
        </div>

        @if (!section.changed) {
        <p class="no-changes">{{ labels.REVIEW_REFINE.NO_CHANGES }}</p>
        }

        <!-- One preview per section; an unchanged one opens straight into its editor. -->
        <div class="section-actions">
          @if (section.changed) {
          <button type="button" class="preview-btn" (click)="openSectionDetail(section)">
            <mat-icon class="btn-icon">unfold_more</mat-icon>
            {{ labels.REVIEW_REFINE.BUTTON.PREVIEW }}
          </button>
          } @else {
          <button type="button" class="preview-btn" [disabled]="!section.isEditable"
            (click)="openSectionDetail(section, true)">
            <mat-icon class="btn-icon">edit</mat-icon>
            {{ labels.REVIEW_REFINE.BUTTON.EDIT_SECTION }}
          </button>
          }
        </div>
      </article>
      }
      </div>
    </div>
  </div>
  <div class="page-action">
    <button type="button" class="aecom_btn" (click)="close()">{{ labels.COMMON.CLOSE }}</button>
    @if (showApply) {
    <button type="button" class="aecom_btn" (click)="applyConfirmedChanges()"
      [disabled]="isApplying || progress().accepted === 0" [title]="labels.REVIEW_REFINE.APPLY_HINT">
      {{ labels.REVIEW_REFINE.BUTTON.APPLY }}
    </button>
    }

    <button type="button" class="aecom_btn--solid" (click)="compileAndExport()">
      {{ labels.REVIEW_REFINE.BUTTON.COMPILE_EXPORT }}
      <mat-icon class="btn-icon">arrow_forward</mat-icon>
    </button>
  </div>

  <!-- Screen 04 · section detail, launched from a section above -->
  @if (detailSection(); as detailSection) {
  <app-change-detail-popup [reportId]="reportId" [section]="detailSection" [sectionText]="detailSectionText()"
    [startInSectionEdit]="detailStartsInSectionEdit()" [acceptingChangeIds]="acceptingChangeIds()"
    (confirmChange)="confirmFromDetail($event)" (declineChange)="declineFromDetail($event)"
    (saveEdit)="saveEditFromDetail($event.change, $event.text)"
    (saveSection)="saveSectionFromDetail(detailSection, $event)" (sectionSaved)="onSectionSavedFromDetail($event)"
    (closed)="closeChangeDetail()">
  </app-change-detail-popup>
  }
  } @else if (!isLoading) {
  <p class="empty-state">{{ labels.REVIEW_REFINE.EMPTY_STATE }}</p>
  }
</div>